export const ARCA_ENTITY_TYPE_PERSONA_FISICA = 1 as const;
export const ARCA_ENTITY_TYPE_PERSONA_JURIDICA = 2 as const;

export const ARCA_VAT_CONDITION_RESPONSABLE_INSCRIPTO = 1 as const;
export const ARCA_VAT_CONDITION_MONOTRIBUTO = 6 as const;
export const ARCA_VAT_CONDITION_EXENTO = 4 as const;
export const ARCA_VAT_CONDITION_CONSUMIDOR_FINAL = 5 as const;
export const ARCA_VAT_CONDITION_CLIENTE_EXTERIOR = 9 as const;
export const ARCA_VAT_CONDITION_IVA_NO_ALCANZADO = 15 as const;
export const ARCA_VAT_CONDITION_MONOTRIBUTISTA_SOCIAL = 13 as const;
export const ARCA_VAT_CONDITION_MONOTRIBUTO_TRABAJADOR_INDEPENDIENTE_PROMOVIDO = 16 as const;

export const arcaBusinessVatConditionOptions = [
  {
    id: ARCA_VAT_CONDITION_RESPONSABLE_INSCRIPTO,
    name: 'Responsable Inscripto',
  },
  {
    id: ARCA_VAT_CONDITION_MONOTRIBUTO,
    name: 'Monotributista',
  },
  {
    id: ARCA_VAT_CONDITION_EXENTO,
    name: 'Exento',
  },
];

export type ArcaBusinessVatCondition = (typeof arcaBusinessVatConditionOptions)[number]['id'];

export const ARCA_CLASS_A_AUTHORIZATION_FULL = 'full' as const;
export const ARCA_CLASS_A_AUTHORIZATION_CBU_INFORMED = 'cbu-informed' as const;
export const ARCA_CLASS_A_AUTHORIZATION_SUBJECT_TO_WITHHOLDING = 'subject-to-withholding' as const;

export const arcaClassAAuthorizationOptions = [
  {
    id: ARCA_CLASS_A_AUTHORIZATION_FULL,
    name: 'Factura A',
  },
  {
    id: ARCA_CLASS_A_AUTHORIZATION_CBU_INFORMED,
    name: 'Factura A con leyenda "Pago en CBU informada"',
  },
  {
    id: ARCA_CLASS_A_AUTHORIZATION_SUBJECT_TO_WITHHOLDING,
    name: 'Factura A con leyenda "Operación sujeta a retención"',
  },
];

export type ArcaClassAAuthorization = (typeof arcaClassAAuthorizationOptions)[number]['id'];

export const ARCA_LEGEND_CBU_INFORMED = 'PAGO EN CBU INFORMADA';
export const ARCA_LEGEND_SUBJECT_TO_WITHHOLDING = 'OPERACIÓN SUJETA A RETENCIÓN';

export const arcaVatConditionOptions = [
  {
    id: ARCA_VAT_CONDITION_RESPONSABLE_INSCRIPTO,
    name: 'Responsable Inscripto',
  },
  {
    id: ARCA_VAT_CONDITION_MONOTRIBUTO,
    name: 'Monotributista',
  },
  {
    id: ARCA_VAT_CONDITION_EXENTO,
    name: 'Exento',
  },
  {
    id: ARCA_VAT_CONDITION_CONSUMIDOR_FINAL,
    name: 'Consumidor Final',
  },
  {
    id: ARCA_VAT_CONDITION_CLIENTE_EXTERIOR,
    name: 'Cliente del Exterior',
  },
  {
    id: ARCA_VAT_CONDITION_IVA_NO_ALCANZADO,
    name: 'IVA No Alcanzado',
  },
  {
    id: ARCA_VAT_CONDITION_MONOTRIBUTISTA_SOCIAL,
    name: 'Monotributista Social',
  },
  {
    id: ARCA_VAT_CONDITION_MONOTRIBUTO_TRABAJADOR_INDEPENDIENTE_PROMOVIDO,
    name: 'Monotributo Trabajador Independiente Promovido',
  },
];

export type ArcaVatCondition = (typeof arcaVatConditionOptions)[number]['id'];

export const arcaVatConditionsRequiringCuit: ArcaVatCondition[] = [
  ARCA_VAT_CONDITION_RESPONSABLE_INSCRIPTO,
  ARCA_VAT_CONDITION_EXENTO,
  ARCA_VAT_CONDITION_MONOTRIBUTO,
  ARCA_VAT_CONDITION_MONOTRIBUTISTA_SOCIAL,
  ARCA_VAT_CONDITION_MONOTRIBUTO_TRABAJADOR_INDEPENDIENTE_PROMOVIDO,
];

export const ARCA_CONCEPT_TYPE_PRODUCTO = 1 as const;
export const ARCA_CONCEPT_TYPE_SERVICIO = 2 as const;
export const ARCA_CONCEPT_TYPE_PRODUCTO_Y_SERVICIO = 3 as const;

export const arcaConceptTypeOptions = [
  {
    id: ARCA_CONCEPT_TYPE_PRODUCTO,
    name: 'Producto',
  },
  {
    id: ARCA_CONCEPT_TYPE_SERVICIO,
    name: 'Servicio',
  },
  {
    id: ARCA_CONCEPT_TYPE_PRODUCTO_Y_SERVICIO,
    name: 'Producto y Servicio',
  },
];

export type ArcaConceptType = (typeof arcaConceptTypeOptions)[number]['id'];

export const ARCA_ALIQUOT_TYPE_21 = 5 as const;
export const ARCA_ALIQUOT_TYPE_10_5 = 4 as const;
export const ARCA_ALIQUOT_TYPE_0 = 3 as const;
export const ARCA_ALIQUOT_TYPE_2_5 = 9 as const;
export const ARCA_ALIQUOT_TYPE_5 = 8 as const;
export const ARCA_ALIQUOT_TYPE_27 = 6 as const;
export const ARCA_ALIQUOT_TYPE_EXENTO = 99 as const;

export const arcaAliquotTypeOptions = [
  {
    id: ARCA_ALIQUOT_TYPE_21,
    name: '21%',
    value: 21,
  },
  {
    id: ARCA_ALIQUOT_TYPE_10_5,
    name: '10.5%',
    value: 10.5,
  },
  {
    id: ARCA_ALIQUOT_TYPE_0,
    name: '0%',
    value: 0,
  },
  {
    id: ARCA_ALIQUOT_TYPE_2_5,
    name: '2.5%',
    value: 2.5,
  },
  {
    id: ARCA_ALIQUOT_TYPE_5,
    name: '5%',
    value: 5,
  },
  {
    id: ARCA_ALIQUOT_TYPE_27,
    name: '27%',
    value: 27,
  },
  {
    id: ARCA_ALIQUOT_TYPE_EXENTO,
    name: 'Exento',
    value: 'exempt' as const,
  },
];

export type ArcaAliquotType = (typeof arcaAliquotTypeOptions)[number]['id'];

export const ARCA_CURRENCY_TYPE_PES = 'PES' as const;
export const ARCA_CURRENCY_TYPE_DOL = 'DOL' as const;

export const arcaCurrencyTypeOptions = [
  {
    id: ARCA_CURRENCY_TYPE_PES,
    name: 'Peso Argentino',
  },
  {
    id: ARCA_CURRENCY_TYPE_DOL,
    name: 'Dólar Estadounidense',
  },
];

export type ArcaCurrencyType = (typeof arcaCurrencyTypeOptions)[number]['id'];

export const ARCA_DOCUMENT_TYPE_CUIT = 80 as const;
export const ARCA_DOCUMENT_TYPE_CUIL = 86 as const;
export const ARCA_DOCUMENT_TYPE_DNI = 96 as const;
export const ARCA_DOCUMENT_TYPE_CDI = 87 as const;
export const ARCA_DOCUMENT_TYPE_LE = 89 as const;
export const ARCA_DOCUMENT_TYPE_LC = 90 as const;
export const ARCA_DOCUMENT_TYPE_CI_EXTRANJERA = 91 as const;
export const ARCA_DOCUMENT_TYPE_PASAPORTE = 94 as const;
export const ARCA_DOCUMENT_TYPE_OTRO = 99 as const;

export const arcaDocumentTypeOptions = [
  {
    id: ARCA_DOCUMENT_TYPE_CUIT,
    name: 'CUIT',
  },
  {
    id: ARCA_DOCUMENT_TYPE_CUIL,
    name: 'CUIL',
  },
  {
    id: ARCA_DOCUMENT_TYPE_DNI,
    name: 'DNI',
  },
  {
    id: ARCA_DOCUMENT_TYPE_CDI,
    name: 'CDI',
  },
  {
    id: ARCA_DOCUMENT_TYPE_LE,
    name: 'LE',
  },
  {
    id: ARCA_DOCUMENT_TYPE_LC,
    name: 'LC',
  },
  {
    id: ARCA_DOCUMENT_TYPE_CI_EXTRANJERA,
    name: 'CI Extranjera',
  },
  {
    id: ARCA_DOCUMENT_TYPE_PASAPORTE,
    name: 'Pasaporte',
  },
  {
    id: ARCA_DOCUMENT_TYPE_OTRO,
    name: 'Documento sin especificar',
  },
];

export type ArcaDocumentType = (typeof arcaDocumentTypeOptions)[number]['id'];

export const ARCA_VOUCHER_TYPE_FACTURA_A = 1 as const;
export const ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_A = 3 as const;
export const ARCA_VOUCHER_TYPE_FACTURA_B = 6 as const;
export const ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_B = 8 as const;
export const ARCA_VOUCHER_TYPE_FACTURA_C = 11 as const;
export const ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_C = 13 as const;
export const ARCA_VOUCHER_TYPE_FACTURA_A_SUBJECT_TO_WITHHOLDING = 51 as const;
export const ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_A_SUBJECT_TO_WITHHOLDING = 53 as const;

export const arcaVoucherTypeOptions = [
  {
    id: ARCA_VOUCHER_TYPE_FACTURA_A,
    name: 'Factura A',
  },
  {
    id: ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_A,
    name: 'Nota de crédito A',
  },
  {
    id: ARCA_VOUCHER_TYPE_FACTURA_B,
    name: 'Factura B',
  },
  {
    id: ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_B,
    name: 'Nota de crédito B',
  },
  {
    id: ARCA_VOUCHER_TYPE_FACTURA_C,
    name: 'Factura C',
  },
  {
    id: ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_C,
    name: 'Nota de crédito C',
  },
  {
    id: ARCA_VOUCHER_TYPE_FACTURA_A_SUBJECT_TO_WITHHOLDING,
    name: 'Factura A con leyenda',
  },
  {
    id: ARCA_VOUCHER_TYPE_NOTA_DE_CREDITO_A_SUBJECT_TO_WITHHOLDING,
    name: 'Nota de crédito A con leyenda',
  },
];

export type ArcaVoucherType = (typeof arcaVoucherTypeOptions)[number]['id'];
